import { Box, Divider, Transition } from '@wix/design-system';
import { useTranslation } from '@wix/fe-essentials/react';
import { AiDisclaimerBanner } from '@wix/rules-panel-ui';
import { useAtomValue } from 'jotai';
import React, { useState } from 'react';
import { headingStructureAIPagesWithResultAtom } from '../../atoms/heading-structure-ai-atoms';
import { activeTabIdAtom, isScanningAtom } from '../../atoms/session-atoms';
import { ACCESSIBILITY_WIZARD_TAB_IDS } from '../../consts';
import { useA11yWizardAdapter } from '../../hooks/use-a11y-wizard-adapter';
import { useOnScanFinished } from '../../hooks/use-on-scan-finished';
import { ScanCompletedNotification } from './scan-completed-notification';
import { WizardFooterDetectedIssues } from './wizard-footer-detected-issues/wizard-footer-detected-issues';
import { WizardFooterManualTasks } from './wizard-footer-manual-tasks';
import { WizardFooterStatement } from './wizard-footer-statement/wizard-footer-statement';
import { WizardFooterWelcome } from './wizard-footer-welcome/wizard-footer-welcome';
export const WizardFooter = _ref => {
  let {
    isEmptyState,
    wasDomOrderCompleted,
    hasSavePermission,
    isPublishedBranch
  } = _ref;
  const {
    t
  } = useTranslation();
  const currentTabId = useAtomValue(activeTabIdAtom);
  const {
    capabilities
  } = useA11yWizardAdapter();
  const compactPanelChrome = capabilities.compactPanelChrome;
  const isScanning = useAtomValue(isScanningAtom);
  const [scanCompleted, setScanCompleted] = useState(false);
  const shouldShowScanCompleted = !isScanning && scanCompleted;
  const pagesWithHeadingAIResult = useAtomValue(headingStructureAIPagesWithResultAtom);
  const showAiHeadingWarning = currentTabId === ACCESSIBILITY_WIZARD_TAB_IDS.DETECTED_TASKS && pagesWithHeadingAIResult.size > 0;
  useOnScanFinished(() => {
    setScanCompleted(true);
  });
  return /*#__PURE__*/React.createElement(Box, {
    align: "center",
    direction: "vertical",
    width: "100%"
  }, isEmptyState ? /*#__PURE__*/React.createElement(WizardFooterWelcome, {
    hasSavePermission: hasSavePermission,
    isPublishedBranch: isPublishedBranch,
    wasDomOrderCompleted: wasDomOrderCompleted
  }) : /*#__PURE__*/React.createElement(React.Fragment, null, !compactPanelChrome && /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    width: "100%"
  }, /*#__PURE__*/React.createElement(Transition, {
    enterAnimation: {
      expand: {
        direction: 'bottomToTop',
        duration: 'medium01'
      }
    },
    exitAnimation: {
      collapse: {
        direction: 'topToBottom',
        duration: 'medium01'
      }
    },
    show: showAiHeadingWarning,
    unmountOnExit: true
  }, /*#__PURE__*/React.createElement(AiDisclaimerBanner, {
    dataHook: "wizard-footer-ai-heading-warning",
    text: t('accessibility-wizard.rules-list.heading-definition.ai.notification-footer.ai-disclaimer'),
    variant: "footer"
  }))), /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "SP3"
  }, currentTabId === ACCESSIBILITY_WIZARD_TAB_IDS.DETECTED_TASKS && /*#__PURE__*/React.createElement(WizardFooterDetectedIssues, null), currentTabId === ACCESSIBILITY_WIZARD_TAB_IDS.MANUAL_TASKS && /*#__PURE__*/React.createElement(WizardFooterManualTasks, null)), /*#__PURE__*/React.createElement(React.Fragment, null, shouldShowScanCompleted && /*#__PURE__*/React.createElement(ScanCompletedNotification, {
    onClose: setScanCompleted
  }), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(Box, {
    backgroundColor: "D75",
    direction: "vertical",
    width: "100%"
  }, /*#__PURE__*/React.createElement(WizardFooterStatement, null)))));
};
//# sourceMappingURL=wizard-footer.js.map